module.exports = __webpack_public_path__ + "img/Unidad10-1.43e27de5.png";